import React, { useEffect } from 'react'
import { useOverlay } from '../context/OverlayContext'
import MonthDetailOverlay from './MonthDetailOverlay'
import ReceiptDetailOverlay from './ReceiptDetailOverlay'

const DetailOverlays: React.FC = () => {
  const { monthId, receiptId, closeMonth, closeReceipt } = useOverlay()

  // Escape closes the topmost overlay (receipt before month).
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return
      if (receiptId !== null) closeReceipt()
      else if (monthId !== null) closeMonth()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [monthId, receiptId, closeMonth, closeReceipt])

  // Lock background scroll while any overlay is open.
  useEffect(() => {
    const open = monthId !== null || receiptId !== null
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [monthId, receiptId])

  return (
    <>
      <MonthDetailOverlay monthId={monthId} onClose={closeMonth} />
      <ReceiptDetailOverlay receiptId={receiptId} onClose={closeReceipt} />
    </>
  )
}

export default DetailOverlays
